import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMeta from 'vue-meta'
import VueShopifyBuy from 'vue-shopify-buy'

Vue.use(VueShopifyBuy, {
  domain: 'estellebourdet.myshopify.com', 
  storefrontAccessToken: '6bc5bb9b7d64afa45a01117b6e31e6fc'
})

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(Vue2TouchEvents)
Vue.use(VueLazyload, {
  listenEvents: [ 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'click' ]
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
